import { CIcon } from '~/icons/types'

export const ciExpandedBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M19.366 12.74a3.585 3.585 0 0 0-.526.053l-2.6-8.107a.59.59 0 0 0-.118-.216c-.005-.006-.012-.01-.017-.015a.584.584 0 0 0-.37-.194l-2.46-.265a.58.58 0 0 0-.653.526.593.593 0 0 0 .526.653l2.076.224 1.891 5.895-6.634 1.994-.504-1.203-.01-.023L7.676 6.6l.686.003h.002a.593.593 0 0 0 .002-1.186l-2.753-.01h-.002a.593.593 0 0 0-.001 1.187l.778.002 2.317 5.525-1.792 1.447a3.597 3.597 0 0 0-2.28-.828 3.633 3.633 0 1 0 3.52 4.492l1.776.233a1.542 1.542 0 0 0 1.486 1.17 1.571 1.571 0 1 0 0-3.143l-.01.002-.464-1.107 6.535-1.965.236.736a3.605 3.605 0 1 0 1.654-.418ZM6.771 15.206a2.41 2.41 0 0 1 .26.682l-.949-.125Zm-2.138 3.615a2.447 2.447 0 1 1 1.338-4.493l-1.71 1.381a.593.593 0 0 0 .295 1.05l2.41.317a2.443 2.443 0 0 1-2.333 1.745Zm5.452-2.532-1.852-.243a3.598 3.598 0 0 0-.529-1.593l1.479-1.194 1.129 2.694a1.59 1.59 0 0 0-.227.336Zm9.281 2.532a2.442 2.442 0 0 1-1.287-4.52l.723 2.254a.592.592 0 0 0 .564.412.618.618 0 0 0 .181-.028.593.593 0 0 0 .384-.746l-.722-2.251c.053-.003.103-.016.157-.016a2.447 2.447 0 1 1 0 4.895Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'expanded-bike',
  type: 'thin'
}
